import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Routes, Route, Navigate } from "react-router-dom";
import { AboutComponent } from "../about";
import { BlogComponent } from "../blog";
import { ContactComponent, MessagesComponent } from "../contact";
import { DownloadCVComponent } from "../download";
import { NavBarComponent } from "../navbar";
import { PortfolioComponent } from "../portfolio";
import { ResumeComponent } from "../resume";
import { SidebarComponent } from "../sidebar";
import { supabase } from "../../supabase";

const LayoutCompnent = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const [theme, setTheme] = React.useState(
    localStorage.getItem("theme") || "dark"
  );

  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  React.useEffect(() => {
    const recordVisit = async () => {
      // Still use sessionStorage as first-line check (fast)
      if (sessionStorage.getItem("visited")) return;

      try {
        // 1. Get current IP
        const response = await fetch("https://api64.ipify.org?format=json");
        const { ip } = await response.json();

        // 2. Check Database: Did this IP visit in the last 24h?
        const yesterday = new Date(
          Date.now() - 24 * 60 * 60 * 1000
        ).toISOString();
        const { count, error: checkError } = await supabase
          .from("visits")
          .select("*", { count: "exact", head: true })
          .eq("ip_address", ip)
          .gt("created_at", yesterday);

        if (!checkError && count !== null && count > 0) {
          sessionStorage.setItem("visited", "true"); // Sync session
          return; // Already recorded today
        }

        // 3. Record new visit
        const { error: insertError } = await supabase.from("visits").insert([
          {
            ip_address: ip,
            user_agent: navigator.userAgent,
          },
        ]);

        if (!insertError) {
          sessionStorage.setItem("visited", "true");
        }
      } catch (err) {
        console.error("Visit tracking failed:", err);
      }
    };

    recordVisit();
  }, []);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const languageOptions = [
    {
      value: "fr",
      label: t("header.language.fr"),
      image: "./assets/images/fr.png",
    },
    {
      value: "en",
      label: t("header.language.en"),
      image: "./assets/images/en.png",
    },
    {
      value: "ar",
      label: t("header.language.ar"),
      image: "./assets/images/ar.png",
    },
  ];

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const handleLanguageChange = (selectedOption: any) => {
    i18next.changeLanguage(selectedOption.value);
    handleCloseDialog();
  };

  return (
    <>
      <main>
        {/* #SIDEBAR */}
        {/* <DownloadCVComponent /> */}
        <SidebarComponent />

        <div className="main-content">
          <NavBarComponent
            setIsOpen={setIsOpen}
            theme={theme}
            toggleTheme={toggleTheme}
          />

          <Routes>
            <Route path="/" element={<AboutComponent />} />
            <Route path="/resume" element={<ResumeComponent />} />
            <Route path="/portfolio" element={<PortfolioComponent />} />
            <Route path="/blog" element={<BlogComponent />} />
            <Route path="/contact" element={<ContactComponent />} />
            <Route path="/contact-me" element={<MessagesComponent />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          {isOpen && (
            <div className="modal" onClick={() => setIsOpen(false)}>
              <div className="modal-content">
                <div className="modal-header">
                  <h2 className="modal-title">{t("general.selectLanguage")}</h2>
                  <button className="close-modal" onClick={handleCloseDialog}>
                    &times;
                  </button>
                </div>
                <div className="language-blocks text">
                  <div className="modal-body">
                    {languageOptions.map((option) => (
                      <div
                        className="language-options"
                        key={option.value}
                        onClick={() => handleLanguageChange(option)}
                      >
                        <img
                          src={option.image}
                          className="block-img"
                          alt="language"
                        />
                        <span>{option.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default LayoutCompnent;
